import { inject, Injectable } from "@angular/core";
import { MapState, ToolState, WorkspaceState } from "@igo2/integration";
import { ChangeDetectorRef } from '@angular/core';
import { LanguageService } from "@igo2/core/language";
import { ConfigService } from "@igo2/core/config";
import { ActivityService } from "@igo2/core/activity";
import {
  CatalogService,
  DataSource, DataSourceService, Feature, FeatureMotion, featureToOl, getLayersLegends,
  IgoMap, Layer, LayerOptions, LayerService, MapService, MapViewOptions, MetadataLayerOptions,
  moveToOlFeatures, QueryableDataSourceOptions, VectorLayer, WMSDataSourceOptions, CatalogItemLayer, CatalogItemGroup,
  GeoWorkspaceOptions,
  QueryService,
  SpatialFilterService,
  SpatialFilterType,
  SpatialFilterQueryType,
  QueryOptions,
  Feature as igoFeature,
  WMSDataSource,
  CatalogItemType,
  CatalogItem,
  isLayerItem
} from '@igo2/geo';
import { BehaviorSubject, firstValueFrom, map, pipe, from, Observable, of, Subscription, take, throwError } from 'rxjs';
export type EntityKey = string | number;
import * as olstyle from 'ol/style';
import { ZzzConfigService } from "src/app/zzz/core/config/config.service";
import type { default as OlGeometry } from 'ol/geom/Geometry';
import olSourceCluster from 'ol/source/Cluster';
import olSourceVector from 'ol/source/Vector';
import { Coordinate } from 'ol/coordinate';
import { Feature as olFeature} from 'ol';
import type { default as OlFeatureClass } from 'ol/Feature';
import { defaults as defaultControls, ScaleLine } from 'ol/control';

// igo2 20 : le chemin profond @igo2/geo/lib/... n'existe plus et la classe
// CompositeCatalog a ete remplacee par l'interface publique ICompositeCatalog.
import { Catalog, ICompositeCatalog as CompositeCatalog } from "@igo2/geo";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { catchError, map as rxMap, switchMap } from 'rxjs/operators';
import html2canvas, { Options } from 'html2canvas';
import olFormatGeoJSON from 'ol/format/GeoJSON';
import olFormatEsriJSON from 'ol/format/EsriJSON';
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { PopUpGdfComponent } from "src/app/integration/sigt-recherche-gdf/pop-up-gdf/pop-up-gdf.component";

import Map from 'ol/Map';
import View from 'ol/View';
import TileLayer from 'ol/layer/Tile';
import OlVectorLayer from 'ol/layer/Vector';
import OSM from 'ol/source/OSM';
import VectorSource from 'ol/source/Vector';
import GeoJSON from 'ol/format/GeoJSON';
import { Fill, Stroke, Style, Circle as CircleStyle } from 'ol/style';
import { fromLonLat, transform } from 'ol/proj';
import { ImpressionGdfService, ExportFicheDroitOptions } from "./impression-gdf.service";
import { Extent } from "ol/extent";
import { StringValueToken } from "html2canvas/dist/types/css/syntax/tokenizer";
import { EntityTableButton, EntityTableColumn, EntityTableColumnRenderer, EntityTableTemplate } from "@igo2/common/entity";
import { PopupLegendSelectorComponent } from "src/app/integration/sigt-recherche-gdf/popup-legend-selector/popup-legend-selector.component";
import { report } from "process";
import { WFS } from "ol/format";


export type GdfContext =
  | 'droitGdf'
  | 'dossierTerrainGdf'
  | 'intervenantGdf'
  | 'transactionGdf'
  | 'avisPriseProssessionGdf';

interface SigtRechercheGdfOptions {
  gdfCatalogId: string;
  controlWMSLayerVisibility: boolean;
  giinIndexName: string;
  giinIndexCatalogId: string;
  metadadaRealisationHtml:string;
}

const defaultServiceOptions: SigtRechercheGdfOptions = {
  gdfCatalogId: "gdf",
  controlWMSLayerVisibility: true,
  giinIndexName: "IDS_INDEX_IMAGERIE_GQ_WMS",
  giinIndexCatalogId: "index-imagerie-gq",
  metadadaRealisationHtml:"Ministère des Ressources naturelles et des Forêts<br>Direction générale de la gestion du territoire public<br>Note : Le présent document n'a aucune portée légale.<br>Le MRNF ne peut garantir l'exactitude des données.<br><br>"
};

interface LayerOptionsWithMetadata extends LayerOptions, MetadataLayerOptions { }

interface Rect {
  x: number;
  y: number;
  w: number;
  h: number;
}

@Injectable({ providedIn: 'root' })
export class RechercheGdfService {
  #mapState = inject(MapState);
  #dataSourceService = inject(DataSourceService);
  #layerService = inject(LayerService);
  #toolState = inject(ToolState);
  #configService = inject(ZzzConfigService);
  catalogService = inject(CatalogService);
  workspaceState = inject(WorkspaceState);
  mapService = inject(MapService);
  http = inject(HttpClient);
  configService = inject(ConfigService);
  languageService = inject(LanguageService);
  dialog = inject(MatDialog);
  impressionGdfService = inject(ImpressionGdfService);
  spatialFilterService = inject(SpatialFilterService);
  queryService = inject(QueryService);
  #activityService = inject(ActivityService);
  activityId: string;
  gdfCatalog: CompositeCatalog;
  gdfLayers: { [key: string]: Layer } = {};
  public layers$ = new BehaviorSubject<Layer[]>([]);
  public defaultStyle: olstyle.Style | ((feature, resolution) => olstyle.Style) = new olstyle.Style({
    fill: new olstyle.Fill({
      color: [89, 200, 20, 0.8]
    }),
    stroke: new olstyle.Stroke({
      width: 1,
      color: 'black'
    }),
    image: new olstyle.Circle({
      radius: 4,
      fill: new olstyle.Fill({
        color: [89, 200, 20, 0.8]
      }),
      stroke: new olstyle.Stroke({
        width: 1,
        color: 'black'
      })
    })
  });

  private format = new olFormatGeoJSON();
  nombreLegends: number;
  urlApi = this.#configService.get().authApiEndPoint;
  dialogRef: MatDialogRef<PopUpGdfComponent>;
  isLayerItem = isLayerItem;

  get map(): IgoMap {
    return this.#mapState.map;
  }

  get baseUrl(): string {
    return this.#configService.get().authApiEndPoint + '/gdf/';
  }

  get options(): SigtRechercheGdfOptions {
    return {
            ...defaultServiceOptions,
            ...(this.#toolState.toolbox.getTool("sigt-recherche-gdf").options as SigtRechercheGdfOptions)
          };
  }

  constructor() {
    this.map.layerController.all$.subscribe(layers => {
      this.layers$.next(<Layer[]> layers.filter(l => this.isLayerItem(l) && String(l.id).startsWith('gdf_')));
    });
  }

  hideAllGdfCreatedLayers(exceptLayerId?: string) {
    let gdfCreatedLayers = this.map.layerController.all.filter(l =>
      this.isLayerItem(l) &&
      exceptLayerId ?
        String(l.id).startsWith('gdf_') && l.id !== exceptLayerId :
        String(l.id).startsWith('gdf_')
    );
    setTimeout(() => {
      gdfCreatedLayers.forEach(l => l.visible = false);
    });
  }

  addSearchResultsToMap(
    layerId: string,
    features: Feature[],
    cdRef: ChangeDetectorRef,
    template: EntityTableTemplate,
    style: olstyle.Style | ((feature, resolution) => olstyle.Style) = null): void {
    if (features.length) {
      if (this.map === undefined) {
        return;
      }

      /* #region: Get the result layer ID/Title count suffix */
      let nextCount = 1;
      const otherLayersOfSameType = this.map.layerController.all.filter(l => this.isLayerItem(l) && new RegExp(`^${layerId}_`).test(String(l.id)));
      if (otherLayersOfSameType.length > 0) {
        otherLayersOfSameType.sort((a, b) => {
          const aId = String(a.id);
          const bId = String(b.id);
          const aCount = parseInt(aId.substring(aId.lastIndexOf('_') + 1));
          const bCount = parseInt(bId.substring(bId.lastIndexOf('_') + 1));
          return aCount < bCount ? 1 : -1;
        });
        const lastId = String(otherLayersOfSameType[0].id);
        nextCount = parseInt(lastId.substring(lastId.lastIndexOf('_') + 1)) + 1;
      }
      /* #endregion: Get the result layer ID/Title count suffix */

      if (nextCount > 1) {
        //show dialog
        this.dialogRef = this.dialog.open(PopUpGdfComponent, {
          width: "500px"
        });
        this.dialogRef.afterClosed().subscribe(result => {
          // if answer is yes create layer with current next count
          if (result) {
            this.createUniqueLayerWithFeatures(layerId, nextCount, features, cdRef, template, style);
          } else {
            // if answer is no delete last layer (nextCount - 1) & create layer with (nextCount -1)
            this.createUniqueLayerWithFeatures(layerId, nextCount - 1, features, cdRef, template, style);
          }
        });
      } else {
        // create layer with current next count
        this.createUniqueLayerWithFeatures(layerId, nextCount, features, cdRef, template, style);
      }
    }
  }

  /**
   * Create a new layer with the given features.
   * If a layer with ID layerId_layerNumber already exists, it will be replaced.
   * @param layerId The layer ID prefix
   * @param layerNumber The number of the layer with the same prefix layerId
   */
  createUniqueLayerWithFeatures(
    layerId: string,
    layerNumber: number,
    features: Feature[],
    cdRef: ChangeDetectorRef,
    template: EntityTableTemplate,
    style: olstyle.Style | ((feature, resolution) => olstyle.Style) = null) {

    // // Remove layer if it already exists
    this.map.layerController.all
      .filter(l => l.id === `${layerId}_${layerNumber}`)
      .map(l => this.map.layerController.remove(l));

    // In case a layer is deleted, setTimeout allows some time for the workspace
    // to realise that its layer is deleted and update accordingly
    setTimeout(() => {
      this.#dataSourceService
        .createAsyncDataSource({
          type: 'vector',
          queryable: true
        } as QueryableDataSourceOptions)
        .pipe(take(1))
        .subscribe((dataSource: DataSource) => {
          let titreCoucheResultat =
            this.languageService.translate.instant('sigt.integration.rechercheGdf.form.serviceGdf.titreCoucheResultat');
          titreCoucheResultat = titreCoucheResultat.replace("{0}", features[0].meta.title).replace("{1}", layerNumber);

          const olLayer = this.#layerService.createLayer({
            id: `${layerId}_${layerNumber}`,
            isIgoInternalLayer: true,
            title: titreCoucheResultat,
            source: dataSource,
            visible: true,
            workspace: { enabled: true },
            style: style || this.defaultStyle,
            igoStyle: {
              editable: true
            }
          }) as VectorLayer;
          const featuresOl = features.map((f) => {
            return featureToOl(f, 'EPSG:3857');
          });

          const ol = dataSource.ol as olSourceVector | olSourceCluster;
          olLayer.options.workspace = Object.assign({}, olLayer.options.workspace, {
            queryOptions: { tabQuery: false }// to avoid showing the toastr-panel
          } as GeoWorkspaceOptions);
          ol.addFeatures(featuresOl);

          this.map.layerController.add(olLayer);
          cdRef.detectChanges();
          this.selectionnerWorkspace(template, olLayer);

          /* #region: //TODO to check the validity of this code */
          const numsDossiers = features.filter(
            (obj, index, self) => index === self.findIndex((t) => t.properties.noDossierUnique === obj.properties.noDossierUnique));
          console.debug('numsDossiers', numsDossiers);
          //Zoomer selon la recheche des features
          var source = olLayer.ol.getSource();
          var extent = source.getExtent();
          this.map.ol.getView().fit(extent, { padding: [20, 20, 20, 20], duration: 1000, maxZoom: numsDossiers.length === 1 ? 16 : 29 });
          /* #endregion: to check the validity of this code */

        });
    }, 100);

  }

  removeLayer(layer: Layer) {
    this.map.layerController.remove(layer);
  }

  selectionnerWorkspace(template: EntityTableTemplate, layer: VectorLayer) {
    const layerId = layer.id;
    let workspaceStoreSubscriptionUntilActivated: Subscription = new Subscription();
    workspaceStoreSubscriptionUntilActivated =
      this.workspaceState.store.entities$.subscribe((workspaceEntries) => {
        const workspaceToActivate = workspaceEntries.find(w => w.id === layerId);
        if (workspaceToActivate) {
          workspaceToActivate.meta.tableTemplate.columns = template.columns;
          this.workspaceState.setActiveWorkspaceById(workspaceToActivate.id);
        }
        workspaceStoreSubscriptionUntilActivated.unsubscribe();
      });
      const workspaceSelectionSubscription =
      this.workspaceState.workspaceSelection$.subscribe();
  }

  selectLegendAndPrintMap = async(row, featureSelectionLayer) => {
    const reportTitles = this.impressionGdfService.getReportTitles(row);
    //show dialog
      const legendDialogRef = this.dialog.open(PopupLegendSelectorComponent, {
        width: "950px",
        data: {
          reportTiles: reportTitles
        }
      });
      legendDialogRef.afterClosed().subscribe(result => {
        // if answer cancel return
        if (result?.confirmed) {
          const legendId = result?.selectedId;
          const reportTitles = result?.reportTitles;
          const mapCenterPoint = result?.mapCenterPoint;
          this.imprimerCartePdf(row,reportTitles, legendId, mapCenterPoint, featureSelectionLayer);
        }
        return;
      });
  };

  imprimerCartePdf = async(row, reportTitles, legendId, mapCenterPoint, featureSelectionLayer) => {
    this.activityId = this.#activityService.register();
    try {
        const overviewRegAdmName: string = "RegionAdministratif";
        const currentYear = new Date().getFullYear();
        const regAdmExtents = await this.getOverviewExtents(row, overviewRegAdmName, this.map, mapCenterPoint);
        const imageryDates = await this.getImageryDates(row, this.map);
        const options:ExportFicheDroitOptions = {
          showGuides: false,
          zoomAuto: false,
          overviewMapExtent: regAdmExtents,
          overviewBaseMapName: "carte_gouv_qc",
          overviewRegAdmName: overviewRegAdmName,
          overviewMapMaxZoomLevel: 7,
          reportTitles: reportTitles,
          metadata: {
            currentYear: currentYear.toString(),
            mapYear: imageryDates,
            mapProjection: this.languageService.translate.instant('sigt.integration.rechercheGdf.form.serviceGdf.projection'),
            metadataRealisation: this.options.metadadaRealisationHtml
          },
          legendImage: this.urlApi+`/sigtapi/legende/${legendId}`,
          mapCenterPoint: mapCenterPoint,
          featureSelectionLayer: featureSelectionLayer
        };
        await this.impressionGdfService.exportFicheDroit(row, this.map, options);
    }
    catch (err) {
      console.error('PDF generation failed', err);
      throw err; // allow caller to handle
    } finally {
      console.log('Finally');
      this.#activityService.unregister(this.activityId);
    }

  }


  checkWMSLayers(gdfLayerName: string): Observable<Layer> {
    if (this.gdfLayers.hasOwnProperty(gdfLayerName)) {
      return of(this.gdfLayers[gdfLayerName]);
    }

    return this.loadLayerFromCatalog(gdfLayerName);
  }

  loadLayerFromCatalog(gdfLayerName: string): Observable<Layer> {
    return this.obternirCatalogueGdf().pipe(
      switchMap(catalog => {
        this.gdfCatalog = catalog;
        if (catalog.composite.length > 0) {
          // igo2 20 type ces methodes avec la classe Catalog, dont `url` est
          // obligatoire, alors qu'un catalogue composite n'en a pas (ICompositeCatalog
          // etend Omit<ICatalog, 'url'>). L'objet transmis est bien celui que la
          // methode attend a l'execution ; seule la declaration est incoherente.
          return this.catalogService.loadCatalogCompositeLayerItems(catalog as unknown as Catalog).pipe(
            switchMap(catalogGroups => {
              if (catalogGroups.length > 0 && catalogGroups[0].type === "group") {
                let layerItems = (catalogGroups[0] as CatalogItemGroup).items;
                layerItems = layerItems.filter(layerItem =>
                  ((layerItem as CatalogItemLayer).options.sourceOptions as WMSDataSourceOptions).params.LAYERS === gdfLayerName);
                return from(layerItems).pipe(
                  switchMap(layerItem => {
                    const wmsDatasourceOptions = ((layerItem as CatalogItemLayer).options.sourceOptions as WMSDataSourceOptions);
                    const layerName = wmsDatasourceOptions.params.LAYERS;
                    return this.#dataSourceService.createAsyncDataSource(wmsDatasourceOptions).pipe(
                      rxMap(source => {
                        const layerOptions = Object.assign((layerItem as CatalogItemLayer).options, { source }, { 'id': `gdf_${layerItem.address}` });
                        const layer = this.#layerService.createLayer(layerOptions);
                        this.gdfLayers[layerName] = layer;
                        return layer;
                      })
                    );
                  }),
                  rxMap(() => this.gdfLayers[gdfLayerName]),
                  catchError(() => of(null))
                );
              }
              return of(null);
            })
          );
        }
        return of(null);
      }),
      catchError(() => of(null))
    );
  }

  obternirCatalogueGdf(): Observable<CompositeCatalog> {
    if (this.gdfCatalog)
      return of(this.gdfCatalog);

    const gdfCatalogId = this.options.gdfCatalogId;
    const url = `${this.#configService.get().authApiEndPoint}/sigtapi/catalog/${gdfCatalogId}`;
    return this.http.get<CompositeCatalog>(url);
  }
  private async getOverviewExtents(row:any, overviewLayerName: string, igoMap: IgoMap, mapCenterPoint:Coordinate): Promise<Extent> {
    if (mapCenterPoint) {
      const regionContainingPoint = await this.findAdmRegionContainingPoint(overviewLayerName, igoMap, mapCenterPoint);

      if (!regionContainingPoint) {
        console.log("Aucune région administrative trouvée pour le point.");
        return null;
      }
      const parser = new olFormatEsriJSON();
      const features = parser.readFeatures(regionContainingPoint) as olFeature[];
      const extent = features[0].getGeometry()?.getExtent();
      return extent;  
    }
    
    if (row.hasOwnProperty("properties")) {
      const nmRegionAdm = row.properties["Région administrative"];
      const match = nmRegionAdm.match(/\(([^)]+)\)/);
      const codeRegAdm = match ? match[1] : null;
      if (codeRegAdm) {
        const regadm = {
            properties: {
                code: codeRegAdm.padStart(2,'0')
            },
            type: "Feature"
          };

          const regionContainingPoint:Feature = await firstValueFrom(
              <any> this.spatialFilterService
                  .loadItemById(regadm, SpatialFilterQueryType.AdmRegion)
          );

        if (regionContainingPoint === null) {
          console.log ("Géométrie de la région administrative non trouvée:" + nmRegionAdm + ":"+ codeRegAdm);
          return null;
        }


        const geojsonFeature = {
          ...regionContainingPoint,
          geometry: {
            type: regionContainingPoint.geometry.type,
            coordinates: regionContainingPoint.geometry.coordinates
          }
        };
        const olFeature = new GeoJSON().readFeature(regionContainingPoint, {

          dataProjection:(<any> regionContainingPoint).geometry.crs.properties.name,
          featureProjection: this.map.viewProjection.getCode()
        }) as OlFeatureClass<OlGeometry>;

        if(olFeature === null) {
          console.log ("OL Feature de la région administrative null:");
          return null;
        }
        return olFeature.getGeometry().getExtent();

    } else {
        console.log("Pas d'attribut pour déterminer la région administratice");
        return null;
    }


    } else {
        console.log("Pas d'attribut pour déterminer la région administratice");
        return null;
      }
  }
  //Get RegAdm by point in polygon query
  private async findAdmRegionContainingPoint(
    overviewRegAdmName: string,
    igoMap: IgoMap,
    mapCenterPoint: Coordinate
  ): Promise<igoFeature | undefined> {

    const regAdmLayer = igoMap.layerController.all.find(
      l => this.isLayerItem(l) && l.options?.name === overviewRegAdmName
    ) as Layer;

    if (!regAdmLayer) {
      console.error(`Unable to locate Overview layer: ${overviewRegAdmName}`);
      return undefined;
    }

    const layerOptions:any = regAdmLayer.dataSource.options;

    if (!layerOptions.urlEsri || !layerOptions.paramsEsri) {
      console.error(`Esri options not configured: ${overviewRegAdmName}`);
      return undefined;
    }
    
    const { urlEsri, paramsEsri } = layerOptions;
    const esriUrl = `${urlEsri}/${paramsEsri.layer}/query`;

    const featureRequest: any = {
      ...paramsEsri,
      geometryType: 'esriGeometryPoint',
      geometry: {
        x: mapCenterPoint[0],
        y: mapCenterPoint[1],
        spatialReference: {
          wkid: 3857
        }
      },
      spatialRel: 'esriSpatialRelIntersects',
      returnGeometry: true,
      outFields: '*',
      inSR: 3857,
      outSR: paramsEsri.srsName,
      resultRecordCount: 1,
      f: 'json'
    };

    // Remove config-only properties
    delete featureRequest.layer;
    delete featureRequest.queryFormat;
    delete featureRequest.maxFeatures;
    delete featureRequest.srsName;
    // Build form-urlencoded body
    let body = new HttpParams();

    Object.entries(featureRequest).forEach(([key, value]) => {
      body = body.set(
        key,
        typeof value === 'object'
          ? JSON.stringify(value)
          : String(value)
      );
    });

    return firstValueFrom(
      this.http
        .post<{ features: igoFeature[] }>(
          esriUrl,
          body.toString(),
          {
            headers: new HttpHeaders({
              'Content-Type': 'application/x-www-form-urlencoded',
              interceptError: 'false'
            })
          }
        )
        .pipe(
          map(response => response.features?.[0]),
          catchError(error => {
            console.error('Erreur esriRequest:', error);
            return of(undefined);
          })
        )
    );
  }
 
  
  //Get imagery dates by querying the GIIN Index
  private async getImageryDates(row:any ,igoMap:IgoMap): Promise<string>{
    const imageryLayer = igoMap.layerController.baseLayers.find(l=>l.options?.name === "mrnf_imagerie");
    if (imageryLayer?.visible){
      const indexLayer = await this.getImageryIndexLayer(igoMap);
      if (indexLayer === null) {
        console.error("Unable to locate imagery index layer");
        return null;
      }
      indexLayer.map = igoMap;
      const queryOptions:QueryOptions = {
        coordinates: fromLonLat(row.geometry.coordinates) as [number, number],
        projection:'EPSG:3857',
        resolution: igoMap.ol.getView().getState().resolution
      };
      const images$ = this.queryService.queryLayer(indexLayer,queryOptions);
      return this.getDates(images$ as Observable<igoFeature[]>);
    }
    return null;
  }
  private async getDates(images$:Observable<igoFeature[]>) {
    const result = await firstValueFrom(
      images$.pipe(
        map(igoFeatures =>
          igoFeatures
            .map(feature => feature.properties['ANNÉE'])
            .filter(value => value !== undefined && value !== null)
            .map(value => String(value))
            .sort()
            .join(', ')
        )
      )
    );
    return result;
  }
  // utility function to locate the GIIN Index Layer
  private async getImageryIndexLayer(igoMap:IgoMap):Promise<Layer>{
    const indexInMap = igoMap.layerController.all.find(l => this.isLayerItem(l) && l.dataSource?.options?.type === "wms"
                                        && (l.dataSource as WMSDataSource)?.options?.url?.includes(this.options.giinIndexName)) as Layer;
    if (indexInMap) {
      return indexInMap;
    } else {
      const giinIndexCatalogId = this.options.giinIndexCatalogId;
      const url = `${this.#configService.get().authApiEndPoint}/sigtapi/catalog/${giinIndexCatalogId}`;
      const giinCatalog = await firstValueFrom(this.http.get<CompositeCatalog>(url));

      const indexLayerItem = this.findMatchingLayerInCatalogItems(
                                  await firstValueFrom(this.catalogService.loadCatalogItems(giinCatalog as unknown as Catalog)),
                                this.options.giinIndexName);
      if (!indexLayerItem){
        console.error ("GIIN Index not found in catalog");
        return null;
      }
      return firstValueFrom(this.#layerService.createAsyncLayer((indexLayerItem as CatalogItemLayer).options));
    }
  }

findMatchingLayerInCatalogItems(
  items: CatalogItem[],
  layerName: string
): CatalogItemLayer | undefined {
  for (const item of items) {
    // If group look in group items
    if (item.type === CatalogItemType.Group && Array.isArray((item as CatalogItemGroup).items)) {
      const found = this.findMatchingLayerInCatalogItems((item as CatalogItemGroup).items, layerName);
      if (found) return found;
    } else if (item.type === CatalogItemType.Layer) {
      const layer = item as CatalogItemLayer;
      const url = (layer.options?.sourceOptions as WMSDataSourceOptions)?.url;

      if (typeof url === 'string' && url.includes(layerName)) {
        return layer;
      }
    }
  }

  return undefined;
}


  rechercherFeatures(layer: any, filter: any): Observable<Feature[]> {
    const wfsTool = new WFS({
      version: layer.options.sourceOptions.paramsWFS.version
    });

    const [featurePrefix, featureType] = layer.options.sourceOptions.paramsWFS.featureTypes.split(':');

    const featureRequest = wfsTool.writeGetFeature({
      srsName: 'EPSG:4326',
      featureNS: layer.options.sourceOptions.urlWfs,
      featurePrefix: featurePrefix,
      featureTypes: [featureType],
      outputFormat: 'application/json',
      filter: filter
    });

    const headers = new HttpHeaders({
      'interceptError': 'false'
    });

    return this.http.post<{ features: Feature[] }>(
      layer.options.sourceOptions.urlWfs,
      new XMLSerializer().serializeToString(featureRequest),
      { headers }
    ).pipe(
      map(response => response.features),
      catchError(error => {
        console.error('Erreur WFS:', error);
        return throwError(() => error);
      })
    );
  }

  getCleanKey(key: string): string {
    return this.languageService.translate.instant(`sigt.integration.rechercheGdf.form.${key}`)
      .replaceAll("'", "’")
      .replaceAll(".", "");
  }

  getPropertyKeyAndTitle(context: GdfContext): { [key: string]: string } {
    const keysByContext: { [key in GdfContext]: string[] } = {
      avisPriseProssessionGdf: [
        'noUar', 'noDossier', 'typeTransaction', 'statutTransaction', 'noAvis', 'intervenant',
        'feuillet', 'datum', 'projection', 'fuseau', 'coordEst', 'coordNord', 'superficie',
        'municipalite', 'mrc', 'regionAdmin', 'designationTerrit','longitude', 'latitude'
      ],
      dossierTerrainGdf: [
        'noUar', 'noDossier', 'statutVersion', 'superficie', 'situation',
        'planEau', 'municipalite', 'mrc', 'regionAdmin', 'feuillet'
      ],
      droitGdf: [
        'noUar', 'noDossier', 'type', 'statut', 'fins', 'intervenant', 'situation',
        'planEau', 'municipalite', 'mrc', 'regionAdmin', 'designationTerrito',
        'feuillet', 'datum', 'projection', 'fuseau', 'coordEst', 'coordNord',
        'longitude', 'latitude', 'superficie', 'remarque'
      ],
      intervenantGdf: [
        'noDossier', 'typeDroit', 'fins', 'statut', 'situation',
        'planEau', 'municipalite', 'mrc', 'regionAdmin','longitude', 'latitude',
        'nomPrenomFacture','entreprise', 'adresse', 'codePostale','telephone', 'telephoneAutre',
        'courriel','nomPrenomCorrespondant','entrepriseCorrespondant','adresseCorrespondant','codePostaleCorrespondant',
        'telephoneCorrespondant','telephoneAutreCorrespondant','courrielCorrespondant'
      ],
      transactionGdf: [
        'noUar', 'noDossier', 'type', 'statut', 'noAvis','intervenant',
        'situation', 'planEau', 'municipalite', 'mrc', 'regionAdministrative', 'designationTerrit',
        'feuillet', 'datum', 'projection', 'fuseau', 'coordEst', 'coordNord',
        'longitude', 'latitude', 'superficie', 'commentaire'
      ]
    };

    const keys = keysByContext[context];
    const result: { [key: string]: string } = {};

    keys.forEach(key => {
      result[key] = this.getCleanKey(`${context}.${key}`);
    });

    return result;
  }

  getEntityTableTemplate(
      context: GdfContext,
      actionHandler?: (row: any, record?: any) => void): EntityTableTemplate {

    const propertyKeyAndTitle = this.getPropertyKeyAndTitle(context);

    const columnsByContext: { [key in GdfContext]: string[] } = {
      avisPriseProssessionGdf: [
        'noUar', 'noDossier', 'typeTransaction', 'statutTransaction', 'noAvis', 'intervenant',
        'feuillet', 'datum', 'projection', 'fuseau', 'coordEst', 'coordNord', 'superficie',
        'municipalite', 'mrc', 'regionAdmin', 'designationTerrit','longitude', 'latitude'
      ],
      dossierTerrainGdf: [
        'noUar', 'noDossier', 'statutVersion', 'superficie', 'situation',
        'planEau', 'municipalite', 'mrc', 'regionAdmin', 'feuillet'
      ],
      droitGdf: [
        'noUar', 'noDossier', 'type', 'statut', 'fins', 'intervenant', 'situation',
        'planEau', 'municipalite', 'mrc', 'regionAdmin', 'designationTerrito',
        'feuillet', 'datum', 'projection', 'fuseau', 'coordEst', 'coordNord',
        'longitude', 'latitude', 'superficie', 'remarque'
      ],
      intervenantGdf: [
        'noDossier', 'typeDroit', 'fins', 'statut', 'situation',
        'planEau', 'municipalite', 'mrc', 'regionAdmin','longitude', 'latitude',
        'nomPrenomFacture','entreprise', 'adresse', 'codePostale','telephone', 'telephoneAutre',
        'courriel','nomPrenomCorrespondant','entrepriseCorrespondant','adresseCorrespondant','codePostaleCorrespondant',
        'telephoneCorrespondant','telephoneAutreCorrespondant','courrielCorrespondant'
      ],
      transactionGdf: [
        'noUar', 'noDossier', 'type', 'statut', 'noAvis','intervenant',
        'situation', 'planEau', 'municipalite', 'mrc', 'regionAdministrative', 'designationTerrit',
        'feuillet', 'datum', 'projection', 'fuseau', 'coordEst', 'coordNord',
        'longitude', 'latitude', 'superficie', 'commentaire'
      ]
    };

    const columns:EntityTableColumn[] = columnsByContext[context].map(key => ({
      title: propertyKeyAndTitle[key],
      name: `properties.${propertyKeyAndTitle[key]}`
    }));
    if (context === 'droitGdf' || context === 'dossierTerrainGdf'){
    // Add action column if needed
    columns.push({
      name: 'action',
      title: '',
      valueAccessor: (row: any, record?: any) => {
        const isSelected = !!record?.state?.selected;
        return [
          {
            icon: context === 'dossierTerrainGdf' ? 'move_down' : 'printer',
            color: 'accent',
            disabled: !isSelected,
            click: (row: any, record?: any) => {
              if (record?.state?.selected && actionHandler) {
                actionHandler(row, record);
              }
            }
          }
        ] as EntityTableButton[];
      },
      renderer: EntityTableColumnRenderer.ButtonGroup
    });
    }
    return { columns };
  }

formatFeaturesForTable(context: GdfContext, features: Feature[]): Feature[] {
    const propertyKeyAndTitle = this.getPropertyKeyAndTitle(context);
    const title = this.getCleanKey(`layers.${context}`);

    let i = 0;

    return features.map(element => {
      const baseProperties: { [key: string]: any } = {
        [propertyKeyAndTitle.noDossier]: this.formatNoDossier(element, context)
      };

      const contextSpecificProperties = this.getContextSpecificProperties(context, element, propertyKeyAndTitle);

      return {
        type: element.type,
        properties: {
          ...baseProperties,
          ...contextSpecificProperties
        },
        geometry: element.geometry,
        meta: {
          id: i++,
          title: title
        }
      };
    });
  }

  private formatNoDossier(element: Feature, context: GdfContext): string {
    switch(context) {
      case 'intervenantGdf':
            return String(element.properties.TER_NO_DOS).padStart(6, '0') + ' ' +
                   String(element.properties.TER_AN_DOS).padStart(2, '0') + ' ' +
                   String(element.properties.TER_NO_SEC).padStart(3, '0');
      default:
            return String(element.properties.TER_NO_DOSSI).padStart(6, '0') + ' ' +
                  String(element.properties.TER_AN_DOSSI).padStart(2, '0') + ' ' +
                  String(element.properties.TER_NO_SECTI).padStart(3, '0');
    }
  }

  private getContextSpecificProperties(
    context: GdfContext,
    element: Feature,
    keys: { [key: string]: string }
  ): { [key: string]: any } {
    switch (context) {
      case 'avisPriseProssessionGdf':
        return {
          [keys.noUar]: element.properties.NO_UAR,
          [keys.typeTransaction]: `${element.properties.TTR_DESCR} (${element.properties.TTR_TYPE})`,
          [keys.statutTransaction]: element.properties.RV_MEANING,
          [keys.noAvis]: element.properties.OSD_NO_AVIS,
          [keys.intervenant]: [
            element.properties.INT_NOM_LIGNE_1,
            element.properties.INT_NOM_LIGNE_2,
            element.properties.INT_NOM_LIGNE_3
          ].filter(v => v).join(' '),
          [keys.feuillet]: element.properties.F20_CODE,
          [keys.datum]: element.properties.TER_CODE_DATUM,
          [keys.projection]: element.properties.TER_TYPE_PROJE,
          [keys.fuseau]: element.properties.TER_NO_FUSEA_HORAI,
          [keys.coordEst]: element.properties.TER_COORD_EST,
          [keys.coordNord]: element.properties.TER_COORD_NORD,
          [keys.superficie]: [
            element.properties.TER_SUPRF,
            element.properties.TER_TYPE_SUPRF
          ].filter(v => v).join(' '),
          [keys.situation]: element.properties.SIT_DESCR,
          [keys.planEau]: element.properties.PLA_NOM,
          [keys.municipalite]: `${element.properties.MUN_NOM} (${element.properties.MUN_NO})`,
          [keys.mrc]: `${element.properties.MRC_NOM} (${element.properties.MRC_NO})`,
          [keys.regionAdmin]: `${element.properties.REA_NOM} (${element.properties.REA_NO})`,
          [keys.designationTerrit]: element.properties.DESIG_CODE_SITAT,
          [keys.longitude]: element.properties.TER_COORD_LONG,
          [keys.latitude]: element.properties.TER_COORD_LAT
        };
      case 'droitGdf':
        return {
          [keys.noUar]: element.properties.NO_UAR,
          [keys.type]: `${element.properties.TDR_DESCR} (${element.properties.TDR_CODE_DROIT})`,
          [keys.statut]: element.properties.RV_MEANING,
          [keys.fins]: `${element.properties.FIN_NO ?? ''} - ${element.properties.FIN_DESCR ?? ''}`,
          [keys.intervenant]: [
            element.properties.INT_NOM_LIGNE_1,
            element.properties.INT_NOM_LIGNE_2,
            element.properties.INT_NOM_LIGNE_3
          ].filter(v => v).join(' '),
          [keys.situation]: element.properties.SIT_DESCR,
          [keys.planEau]: element.properties.PLA_NOM,
          [keys.municipalite]: `${element.properties.MUN_NOM} (${element.properties.MUN_NO})`,
          [keys.mrc]: `${element.properties.MRC_NOM} (${element.properties.MRC_NO})`,
          [keys.regionAdmin]: `${element.properties.REA_NOM} (${element.properties.REA_NO})`,
          [keys.designationTerrito]: element.properties.DESIG_CODE_SITAT,
          [keys.feuillet]: element.properties.F20_CODE,
          [keys.datum]: element.properties.TER_CODE_DATUM,
          [keys.projection]: element.properties.TER_TYPE_PROJE,
          [keys.fuseau]: element.properties.TER_NO_FUSEA_HORAI,
          [keys.coordEst]: element.properties.TER_COORD_EST,
          [keys.coordNord]: element.properties.TER_COORD_NORD,
          [keys.longitude]: element.properties.TER_COORD_LONG, //element.geometry.coordinates[0],
          [keys.latitude]: element.properties.TER_COORD_LAT, //element.geometry.coordinates[1],
          [keys.superficie]: [
            element.properties.TER_SUPRF,
            element.properties.TER_TYPE_SUPRF
          ].filter(v => v).join(' '),
          [keys.remarque]: element.properties.DRT_REMAR === null ? '' : element.properties.DRT_REMAR
        };

      case 'dossierTerrainGdf':
        return {
          [keys.noUar]: element.properties.NO_UAR,
          [keys.statutVersion]: element.properties.RV_MEANING,
          [keys.superficie]: [
            element.properties.TER_SUPRF,
            element.properties.TER_TYPE_SUPRF
          ].filter(v => v).join(' '),
          [keys.situation]: element.properties.SIT_DESCR,
          [keys.planEau]: element.properties.PLA_NOM,
          [keys.municipalite]: `${element.properties.MUN_NOM} (${element.properties.MUN_NO})`,
          [keys.mrc]: `${element.properties.MRC_NOM} (${element.properties.MRC_NO})`,
          [keys.regionAdmin]: `${element.properties.REA_NOM} (${element.properties.REA_NO})`,
          [keys.feuillet]: element.properties.F20_CODE
        };
      case 'intervenantGdf':
        return {
          [keys.typeDroit]: element.properties.TYP_DRT,
          [keys.fins]: element.properties.FINS,
          [keys.statut]: element.properties.STATUT,
          [keys.situation]: element.properties.SIT_DES,
          [keys.planEau]: element.properties.PLA_NOM,
          [keys.municipalite]: element.properties.MUN,
          [keys.mrc]: element.properties.MRC,
          [keys.regionAdmin]: element.properties.REG_ADM,
          [keys.longitude]: element.properties.TER_LON,
          [keys.latitude]: element.properties.TER_LAT,
          [keys.nomPrenomFacture]: element.properties.NOM_PR_FAC,
          [keys.entreprise]: element.properties.NOM_ENT,
          [keys.adresse]:element.properties.ADR,
          [keys.codePostale]: element.properties.ADR_CO_POS,
          [keys.telephone]: element.properties.TEL_X,
          [keys.telephoneAutre]:element.properties.TEL_A_X,
          [keys.courriel]:  element.properties.EMAIL,
          [keys.nomPrenomCorrespondant]: element.properties.COR_NOM_PR,
          [keys.entrepriseCorrespondant]: element.properties.COR_ENT,
          [keys.adresseCorrespondant]: element.properties.COR_ADR,
          [keys.codePostaleCorrespondant]: element.properties.COR_CO_POS,
          [keys.telephoneCorrespondant]: element.properties.COR_TELE_X,
          [keys.telephoneAutreCorrespondant]: element.properties.COR_TEA_X,
          [keys.courrielCorrespondant]: element.properties.COR_EMAIL
        };

      case 'transactionGdf':
        return {
          [keys.noUar]: element.properties.NO_UAR,
          [keys.type]: `${element.properties.TTR_DESCR} (${element.properties.TTR_TYPE})`,
          [keys.statut]: element.properties.RV_MEANING,
          [keys.noAvis]: element.properties.OSD_NO_AVIS,
          [keys.intervenant]: [
            element.properties.INT_NOM_LIGNE_1,
            element.properties.INT_NOM_LIGNE_2,
            element.properties.INT_NOM_LIGNE_3
          ].filter(v => v).join(' '),
          [keys.situation]: element.properties.SIT_DESCR,
          [keys.planEau]: element.properties.PLA_NOM,
          [keys.municipalite]: `${element.properties.MUN_NOM} (${element.properties.MUN_NO})`,
          [keys.mrc]: `${element.properties.MRC_NOM} (${element.properties.MRC_NO})`,
          [keys.regionAdministrative]: `${element.properties.REA_NOM} (${element.properties.REA_NO})`,
          [keys.designationTerrit]: element.properties.DESIG_CODE_SITAT,
          [keys.feuillet]: element.properties.F20_CODE,
          [keys.datum]: element.properties.TER_CODE_DATUM,
          [keys.projection]: element.properties.TER_TYPE_PROJE,
          [keys.fuseau]: element.properties.TER_NO_FUSEA_HORAI,
          [keys.coordEst]: element.properties.TER_COORD_EST,
          [keys.coordNord]: element.properties.TER_COORD_NORD,
          [keys.longitude]: element.properties.TER_COORD_LONG,
          [keys.latitude]: element.properties.TER_COORD_LAT,
          [keys.superficie]: [
            element.properties.TER_SUPRF,
            element.properties.TER_TYPE_SUPRF
          ].filter(v => v).join(' '),
          [keys.commentaire]: element.properties.TRS_COM === null ? '' : element.properties.TRS_COM
        };

      default:
        return {};
    }
  }

}
